exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logo[data-v-32acba03] {\n  height: 24px;\n  fill: #333;\n  margin-top: 0.3rem;\n}\n.profile-photo[data-v-32acba03] {\n  width: 2rem;\n  height: 2rem;\n  margin: -.375rem 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-32acba03","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Navbar.vue
// module id = 2Rwn
// module chunks = 97